import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "teeth-removed",
  "use": "teeth-removed-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"teeth-removed\">\n<circle cx=\"6.50003\" cy=\"6.5\" r=\"6\" fill=\"white\" stroke=\"currentColor\" />\n<path d=\"M7.84828 7.90723L5.00015 3.99994M5.15203 7.90723L8.00015 3.99994\" stroke=\"currentColor\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol